import { defineStore } from 'pinia'
import axios from 'axios'

export const useCarStore = defineStore('carStore', {
  state: () => ({
    cars: [],
    loading: false,
  }),
  actions: {
    async fetchCars() {
        console.log('[fetchCars] action called');

      this.loading = true
      try {
        const response = await axios.get(
          'https://api.github.com/repos/Fedaa123-12/cardata/contents/cardata.xml',
          {
            headers: {  
              Authorization: 'Bearer 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',
              Accept: 'application/vnd.github.v3.raw'
            }
          }
        )
        
        const parser = new DOMParser()
        const xmlDoc = parser.parseFromString(response.data, 'text/xml')
        const cars = Array.from(xmlDoc.getElementsByTagName('Car')).map(car => ({
          ID: car.getElementsByTagName('ID')[0].textContent,
          Name: car.getElementsByTagName('Name')[0].textContent,
          Model: car.getElementsByTagName('Model')[0].textContent,
          FullModel: car.getElementsByTagName('FullModel')[0].textContent,
          EyeCatcher: car.getElementsByTagName('EyeCatcher')[0].textContent,
          Description: car.getElementsByTagName('Description')[0]?.textContent || '',
          Value: parseInt(car.getElementsByTagName('Value')[0].textContent),
          Mileage: parseInt(car.getElementsByTagName('Mileage')[0].textContent),
          YearOfManu: car.getElementsByTagName('YearOfManu')[0].textContent,
          CatStat: car.getElementsByTagName('CatStat')[0].textContent,
          FuelType: car.getElementsByTagName('FuelType')[0].textContent,
          Transmission: car.getElementsByTagName('Transmission')[0].textContent,
          Colour: car.getElementsByTagName('Colour')[0]?.textContent,
          ExtraFeatures: car.getElementsByTagName('ExtraFeatures')[0]?.textContent,
          Reg: car.getElementsByTagName('Reg')[0]?.textContent,
          Image: car.getElementsByTagName('Image')[0].textContent,
          Video: car.getElementsByTagName('Video')[0]?.textContent || '',
          MetaTag: car.getElementsByTagName('metaCatcher')[0]?.textContent || '', 
          Tax: car.getElementsByTagName('Tax')[0]?.textContent || '', 
          Insurance: car.getElementsByTagName('Insurance')[0]?.textContent || '', 
          Mpg:car.getElementsByTagName('Mpg')[0]?.textContent || '',
          AT:car.getElementsByTagName('AT')[0]?.textContent || '',
        }))
        this.cars = cars
      } catch (err) {
        console.error('Error fetching cars:', err)
      } finally {
        this.loading = false
      }
      console.log("test")
    }
  }
})
